"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var pusher_js_1 = __importDefault(require("pusher-js"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var pusher = null;
function Producer(_a) {
    var channel = _a.channel, id = _a.id, isBroadcasting = _a.isBroadcasting, user = _a.user;
    if (!id) {
        return react_1.default.createElement("h1", null, "Livestream id not provided");
    }
    var _b = react_1.useState({ loading: true }), livestream = _b[0], setLivestream = _b[1];
    var _c = react_1.useState({
        loading: true,
        data: {
            external_id: null,
        },
    }), video = _c[0], setVideo = _c[1];
    var _d = react_1.useState(ra_fetch_1.Fetcher.collection()), eventsInUse = _d[0], setEventsInUse = _d[1];
    var _e = react_1.useState(ra_fetch_1.Fetcher.collection()), eventsAvailable = _e[0], setEventsAvailable = _e[1];
    var _f = react_1.useState(ra_fetch_1.Fetcher.collection()), scores = _f[0], setScores = _f[1];
    function abbreviateTeamName(name) {
        if (name === void 0) { name = 'n/a'; }
        return name.replace(/\s/g, '').slice(0, 3).toUpperCase();
    }
    function createClip(eventId, timestamp) {
        var jw_id = video.data.external_id;
        var padding = 30;
        var clipDuration = 10;
        var pubTime = new Date(livestream.data.video.date);
        var clipTime = new Date(pubTime.getTime() + timestamp * 1000);
        var diff = Math.round((clipTime.getTime() - pubTime.getTime()) / 1000);
        var trimIn = diff > padding ? diff - padding : diff;
        var trimOut = diff + clipDuration + padding;
        ra_fetch_1.Fetcher.api('media')
            .store('clips', {
            id: jw_id,
            livestream_id: livestream.data.livestream_id,
            title: "Clip " + eventId,
            trim_in: storybook_1.Helpers.timeFormatted(trimIn),
            trim_out: storybook_1.Helpers.timeFormatted(trimOut),
            channel_id: channel.id,
        })
            .then(function (clip) {
            ra_fetch_1.Fetcher.api('producer')
                .update('events_in_use.attach_clip', {
                id: eventId,
                clip_id: clip.data.external_id,
                jw_id: jw_id,
            })
                .then(function () { return getEventsInUse(jw_id); });
        });
    }
    function deleteEvent(eventId) {
        var jw_id = video.data.external_id;
        ra_fetch_1.Fetcher.api('producer')
            .delete('events_in_use', {
            id: eventId,
            jw_id: jw_id,
        })
            .then(function () { return getEventsInUse(jw_id); });
    }
    function editEvent(eventId) {
        ra_fetch_1.Fetcher.api('producer')
            .show('events_in_use', {
            id: eventId,
            jw_id: video.data.external_id,
        });
    }
    function getEventsAvailable(sport_id) {
        return ra_fetch_1.Fetcher.api('producer')
            .index('events_available', { sport_id: sport_id })
            .then(function (events) { return setEventsAvailable(events); });
    }
    function getEventsInUse(jw_id) {
        return ra_fetch_1.Fetcher.api('producer')
            .index('events_in_use', { jw_id: jw_id })
            .then(function (events) { return setEventsInUse(events); });
    }
    function getScores(jw_id) {
        ra_fetch_1.Fetcher.api('producer')
            .show('scores', { jw_id: jw_id })
            .then(function (scores) { return setScores(scores); });
    }
    function getTeamScore(teamId) {
        if (!teamId || !scores.data || !scores.data.length) {
            return 0;
        }
        return scores.data.filter(function (score) {
            return parseInt(score.team_id) === parseInt(teamId);
        }).first().score || 0;
    }
    function getTeamsFromVideoData() {
        var _a, _b;
        var _c = video.data, _d = _c.team, team = _d === void 0 ? {} : _d, _e = _c.opponent, opponent = _e === void 0 ? {} : _e;
        return [
            __assign(__assign({}, team), { nameAbbreviated: abbreviateTeamName((_a = team === null || team === void 0 ? void 0 : team.club) === null || _a === void 0 ? void 0 : _a.label), colour: '#F7323F', score: getTeamScore(team === null || team === void 0 ? void 0 : team.id) }),
            __assign(__assign({}, opponent), { nameAbbreviated: abbreviateTeamName((_b = opponent === null || opponent === void 0 ? void 0 : opponent.club) === null || _b === void 0 ? void 0 : _b.label), colour: '#FF8900', score: getTeamScore(opponent === null || opponent === void 0 ? void 0 : opponent.id) }),
        ];
    }
    function graphicsUrl(id) {
        var baseUrl = process.env.NEXT_PUBLIC_STORYBOOK_SERVICE_GRAPHICS_OVERLAY_URL;
        return id ? baseUrl + "/" + id : '';
    }
    function isLoading() {
        return video.loading
            || eventsInUse.loading
            || eventsAvailable.loading
            || livestream.loading;
    }
    function submitEventForm(eventId, data) {
        var jw_id = video.data.external_id;
        var body = __assign(__assign(__assign({ jw_id: jw_id, timestamp: data.timestamp, description: data.description }, (data.selectedTeam.hasOwnProperty('id')
            ? { team_id: data.selectedTeam.id }
            : {})), data.selectedEvent), { event_template_id: data.selectedEvent.event_template_id.toString() });
        var promise = !eventId
            ? ra_fetch_1.Fetcher.api('producer')
                .store('events_in_use', body)
            : ra_fetch_1.Fetcher.api('producer')
                .update('events_in_use', __assign({ id: eventId }, body));
        return promise.then(function () { return getEventsInUse(jw_id); });
    }
    react_1.useEffect(function () {
        ra_fetch_1.Fetcher.api('backend')
            .show('livestreams', {
            channel_id: channel.id,
            id: id,
            details: true,
        })
            .then(function (livestream) {
            var _a, _b;
            if (livestream.errors) {
                throw new Error(JSON.stringify(livestream.errors));
            }
            setLivestream(livestream);
            var videoId = (_b = (_a = livestream === null || livestream === void 0 ? void 0 : livestream.data) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.id;
            ra_fetch_1.Fetcher.api('backend')
                .show('videos', {
                id: videoId,
                details: true,
                channel_id: channel.id,
                resource: 'VideoFull',
            })
                .then(function (video) {
                if (video.errors) {
                    throw new Error(JSON.stringify(video.errors));
                }
                setVideo(video);
                getScores(video.data.external_id);
                getEventsInUse(video.data.external_id);
                getEventsAvailable(video.data.sport.name);
            })
                .catch(function (err) { return console.error(err); });
        });
    }, [isBroadcasting]);
    react_1.useEffect(function () {
        var channelId = video.data.external_id
            ? "" + video.data.external_id
            : null;
        if (!channelId)
            return;
        pusher = new pusher_js_1.default(process.env.NEXT_PUBLIC_STORYBOOK_PUSHER_APP_KEY, {
            cluster: process.env.NEXT_PUBLIC_STORYBOOK_PUSHER_APP_CLUSTER,
        });
        var channel = pusher.subscribe(channelId);
        channel.bind('scoreUpdated', function (_a) {
            var message = _a.message;
            return setScores(function (scores) {
                var _a;
                return (__assign(__assign({}, scores), { data: __spreadArray(__spreadArray([], (_a = scores === null || scores === void 0 ? void 0 : scores.data) === null || _a === void 0 ? void 0 : _a.filter(function (score) {
                        return parseInt(score === null || score === void 0 ? void 0 : score.team_id) !== parseInt(message.team_id);
                    })), [message]) }));
            });
        });
        return function cleanUp() {
            // Unbind all handlers
            channel.unbind();
            // Disconnect from Pusher
            pusher.disconnect();
        };
    }, [video.data.external_id]);
    if (video.errors) {
        return react_1.default.createElement(storybook_1.Notifications.Notification, { type: 'danger', open: true, title: 'Oeps er is iets fout gegaan..', description: 'Probeer het later nog eens.', appendClassname: 'w-full' });
    }
    if (isLoading()) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return (react_1.default.createElement(storybook_1.Pages.Dashboard.Producer.ProducerPage, { channel: channel, createClip: function (id, timestamp) { return createClip(id, timestamp); }, editEvent: function (id) { return editEvent(id); }, eventsInUse: eventsInUse.data, eventsMatch: eventsAvailable.data
            .filter(function (event) { return event.event_type === 'match'; })
            .sort(function (a, b) {
            if ((a === null || a === void 0 ? void 0 : a.order) > (b === null || b === void 0 ? void 0 : b.order))
                return 1;
            if ((b === null || b === void 0 ? void 0 : b.order) > (a === null || a === void 0 ? void 0 : a.order))
                return -1;
            return 0;
        })
            .filter(function (event) {
            return !eventsInUse.data.filter(function (_a) {
                var event_template_id = _a.event_template_id;
                return event_template_id === event.event_template_id;
            }).length;
        }), eventsTimeline: eventsAvailable.data
            .filter(function (event) { return ['timeline', 'score'].includes(event.event_type); }), deleteEvent: function (id) { return deleteEvent(id); }, isBroadcasting: !video.data.hidden, graphicsUrl: graphicsUrl(video.data.external_id), submitEventForm: function (_a) {
            var _b = _a.id, id = _b === void 0 ? null : _b, data = __rest(_a, ["id"]);
            return submitEventForm(id, data);
        }, setVideo: function (video) { return setVideo(__assign(__assign({}, video), { data: video })); }, user: user, video: video.data, teams: getTeamsFromVideoData() }));
}
exports.default = Producer;
